import { StDot } from './Dot.styled'

type Props = {
  color: string
}

const Dot = ({ color }: Props) => <StDot color={color} />

export { Dot }
